import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import { applyShellClasses } from './shell/useShell'
import './styles/tokens.css'
import './styles/base.css'
import './styles/legacy/desktop.css'
import './styles/legacy/phone.css'
import './styles/legacy/quiz-phone.css'
import './styles/legacy/quiz-desktop.css'
import './styles/legacy/map-desktop.css'
import './styles/legacy/map-phone.css'
import './styles/shell.css'

applyShellClasses()
createApp(App).use(router).mount('#app')
